module.exports = __webpack_public_path__ + "img/yingyong.be430b0b.png";